export default {
  ACTIVE: "111f0b88-ff90-4e2e-a821-a7c18da94759",
  TERMINATED: "222f0abc-ff90-4e2e-a821-a7c18da94759",
  WATCH: "333f0789-ff90-4e2e-a821-a7c18da94759"
};
